<template>
  <div class="item-unit-modal">
    <form action="" @submit.prevent="submitContactData">
      <div class="card-body">
        <div class="form-group row">
          <div class="col-md-12">
            <label class="form-label">{{ $t('islamic_finance.step_name') }}</label><span class="text-danger"> *</span>
            <div class="base-read-box base-read-box-field" v-html="formData.name"
            />
          </div>

          <div class="col-md-12">
            <label class="form-label">{{ $t('islamic_finance.form_title') }}</label><span class="text-danger"> *</span>
            <base-input
              ref="title"
              :invalid="$v.formData.title.$error"
              v-model.trim="formData.title"
              type="text"
              name="title"
              tab-index="3"
              @input="$v.formData.title.$touch()"
            />
            <div v-if="$v.formData.title.$error">
              <span v-if="!$v.formData.title.required" class="text-danger">
                {{ $tc('validation.required') }}
              </span>
            </div>
          </div>
          <div class="col-md-12">
            <label class="form-label">{{ $t('islamic_finance.form_message') }}</label><span class="text-danger"> *</span>
            <ckeditor :invalid="$v.formData.message.$error" @input="$v.formData.message.$touch()" :config="editorConfig" v-model="formData.message" class="editor-instance" />

            <div v-if="$v.formData.message.$error">
              <span v-if="!$v.formData.message.required" class="text-danger">
                {{ $tc('validation.required') }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <base-button
          :outline="true"
          class="mr-3"
          color="theme"
          type="button"
          @click="closeContactModal"
        >
          {{ $t('general.cancel') }}
        </base-button>
        <base-button
          :loading="isLoading"
          color="theme"
          icon="save"
          type="submit"
        >
          {{ !isEdit ? $t('general.save') : $t('general.update') }}
        </base-button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import BaseTextArea from './../../BaseTextArea.vue'

const { required } = require('vuelidate/lib/validators')
export default {
  components: { BaseTextArea },
  mixins: [validationMixin],
  data () {
    return {
      isEdit: false,
      isLoading: false,
      formData: {
        id: null,
        name: null,
        title: null,
        message: null
      },
      editorData: '<p>Content of the editor.</p>',
      editorConfig: {
        toolbar: [
					[ 'Source' ],
					[ 'Styles', 'Format', 'Font', 'FontSize' ],
					[ 'Bold', 'Italic'],
          ['NumberedList', 'BulletedList', 'Outdent', 'Indent','Blockquote', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock' ],
					[ 'Undo', 'Redo' ]
				]
      }
    }
  },
  computed: {
    ...mapGetters('modal', [
      'modalDataID',
      'modalData',
      'modalActive'
    ])
  },
  watch: {

  },
  created () {},
  validations: {
    formData: {
      name: {
        required
      },
      title: {
        required
      },
      message : {
        required
      }
    }
  },
  async mounted () {
    this.$refs.title.focus = true
    if (this.modalDataID) {
      this.isEdit = true
      this.setData()
    }
  },
  methods: {
    ...mapActions('modal', [
      'closeModal',
      'resetModalData'
    ]),
    ...mapActions('islamicFinanceForm', [
      'UpdateIslamicFormData'
    ]),
    resetFormData () {
      this.formData = {
        id: null,
        name: null,
        title: null,
        message: null
      }
      this.$v.formData.$reset()
    },
    async submitContactData () {
      this.$v.formData.$touch()
      if (this.$v.$invalid) {
        return true
      }
      let response = await this.UpdateIslamicFormData(this.formData)
      if (response.data) {
        window.toastr['success'](this.$t('settings.contacts.updated_message'))
        this.closeContactModal()
        return true
      }
      window.toastr['error'](response.data.error)
    },
    async setData () {
      this.formData = {
        id: this.modalData.id,
        name: this.modalData.name,
        title: this.modalData.title,
        message: this.modalData.message
      }
      this.editorData = this.modalData.message
    },
    closeContactModal () {
      this.resetModalData()
      this.resetFormData()
      this.closeModal()
    }
  }
}
</script>
